import { createAsyncThunk } from '@reduxjs/toolkit';
import { MyKnownError, thunkErrorHandler } from 'features/thunkError';
import { AppDispatch } from 'app/store';
import {
  fetchLatestInvoiceBySubscriptionId,
  patchPatLatestInvoiceBySubscriptionId
} from 'api/billing/invoices';
import { IInvoice } from '../invoices/invoicesTypes';

export const getLatestInvoiceBySubscriptionId = createAsyncThunk<
  IInvoice,
  string,
  {
    dispatch: AppDispatch;
    rejectValue: string | unknown;
  }
>('@@invoices/getLatestInvoiceBySubscriptionId', async (subscriptionId, thunkApi) => {
  try {
    const res = await fetchLatestInvoiceBySubscriptionId(subscriptionId);
    return res.data;
  } catch (err) {
    return thunkErrorHandler(err as MyKnownError, thunkApi.rejectWithValue);
  }
});

export const payLatestInvoiceBySubscriptionId = createAsyncThunk<
  IInvoice,
  string,
  {
    dispatch: AppDispatch;
    rejectValue: string | unknown;
  }
>('@@invoices/payLatestInvoiceBySubscriptionId', async (subscriptionId, thunkApi) => {
  try {
    const res = await patchPatLatestInvoiceBySubscriptionId(subscriptionId);
    return res.data;
  } catch (err) {
    return thunkErrorHandler(err as MyKnownError, thunkApi.rejectWithValue);
  }
});